import type { IconData } from '@stacksjs/iconify-core'

export const am1x1: IconData = {
  "body": "<path fill=\"#d90012\" d=\"M0 0h512v170.7H0z\"/><path fill=\"#0033a0\" d=\"M0 170.7h512v170.6H0z\"/><path fill=\"#f2a800\" d=\"M0 341.3h512V512H0z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default am1x1
